import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import UnfollowEntityOnboardingMutation from 'buyside/graphql/mutations/UnfollowEntityOnboarding.graphql';
import RemoveMassImportMutation from 'buyside/graphql/mutations/RemoveMassImport.graphql';
import UnfollowUserOnboardingMutation from 'buyside/graphql/mutations/UnfollowUserOnboarding.graphql';

import OnboardingSidebar from 'buyside/components/presentation/Onboarding/OnboardingSidebar/onboardingSidebar';

const OnboardingSidebarContainer = props => {
  return (
    <Mutation mutation={UnfollowUserOnboardingMutation}>
      {unfollowUser => (
        <Mutation mutation={UnfollowEntityOnboardingMutation}>
          {unfollowEntity => (
            <Mutation mutation={RemoveMassImportMutation}>
              {removeMassImport => (
                <OnboardingSidebar
                  unfollowEntity={unfollowEntity}
                  unfollowUser={unfollowUser}
                  removeMassImport={removeMassImport}
                  {...props}
                />
              )}
            </Mutation>
          )}
        </Mutation>
      )}
    </Mutation>
  );
};

export default OnboardingSidebarContainer;
